import Carousel from 'react-bootstrap/Carousel';
import mit from "../../Assets/Carousal/MIT.png";
import voiss from "../../Assets/Carousal/VOIS.png";
import veritas from "../../Assets/Carousal/VERITAS.png";
import pvtcoet from "../../Assets/Carousal/PVTCOET.png"
import i2it from "../../Assets/Carousal/I2IT.png"
import visai from "../../Assets/Carousal/VISAI.png"

function IndividualIntervalsExample() {
  return (
    <Carousel>
      <Carousel.Item interval={2000}>
        <img
          className="e-block"
          src={mit}
          style={{ height: "500px" }}
          alt="First slide"
        />
        <Carousel.Caption>
          <h3>Codebreak 3.0 @MIT ADT</h3>
          <p>Protecting Marine Life from Mesh entanglements</p>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item interval={500}>
        <img
          className="e-block"
          src={visai}
          alt="Second slide"
        />
        <Carousel.Caption>
          <h3>First 🏆 VISAI 2022</h3>
          <p>Crown of Thorns detection for Coral life protection</p>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
        <img
          className="e-block"
          src={voiss}
          alt="Third slide"
        />
        <Carousel.Caption>
          <h4>Vodaphone Idea Innovation Challenge</h4>
          <p>
          7th Rank 🏆 Alexbot 
          </p>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
        <img
          className="e-block"
          src={i2it}
          alt="Fourth slide"
        />
        <Carousel.Caption>
          <h3> Pune Smart India Hackathon </h3>
          <p>
           Top 30 ⭐️ Monetizing data for Medical research
          </p>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
        <img
          className="e-block"
          src={veritas}
          alt="Fifth slide"
        />
        <Carousel.Caption>
          <h3> Veritas Illuminate Uconnect 2023 </h3>
          <p color='black'>
           Top 10 ⭐️ Multicloud service management platform
          </p>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
        <img
          className="e-block"
          src={pvtcoet}
          alt="Sixth slide"
        />
        <Carousel.Caption>
          <h3> GDSC Ideathon @Pvtcoet</h3>
          <p>
            3rd 🥉 Voice agent for student skill development
          </p>
        </Carousel.Caption>
      </Carousel.Item>
    </Carousel>
  );
}

export default IndividualIntervalsExample;